import LegalLayout from "../components/LegalLayout";

const H = ({ children }) => <h2 className="font-heading text-xl mt-8 mb-2">{children}</h2>;
const P = ({ children }) => <p className="text-muted-foreground">{children}</p>;
const Ul = ({ children }) => <ul className="list-disc ml-5 space-y-1.5 text-muted-foreground">{children}</ul>;

const TermsOfService = () => (
  <LegalLayout title="Terms of Service" lastUpdated="19 February 2026">
    <P>These Terms govern your use of Vivo Musician Management (&ldquo;Vivo&rdquo;, &ldquo;the Service&rdquo;). By creating an account or joining a band on Vivo you agree to these Terms.</P>

    <H>1. The Service</H>
    <P>Vivo is a web application provided by James Fiddeman (&ldquo;we&rdquo;, &ldquo;us&rdquo;) that helps bands manage rehearsals, concerts, members, music, finance, inventory and documents. Features vary by subscription plan.</P>

    <H>2. Accounts &amp; eligibility</H>
    <Ul>
      <li>You must be at least 16 years old to create an account (or 13 with verifiable parental consent).</li>
      <li>You are responsible for the accuracy of the information you provide and for keeping your password secure.</li>
      <li>One person, one account. Do not share accounts.</li>
    </Ul>

    <H>3. Acceptable use</H>
    <Ul>
      <li>Don&apos;t use Vivo for anything illegal, abusive, or to harass others.</li>
      <li>Don&apos;t upload content you don&apos;t have the right to share (e.g. copyrighted sheet music you haven&apos;t licensed).</li>
      <li>Don&apos;t attempt to reverse-engineer or disrupt the Service.</li>
      <li>Admins must only add players who have consented to being added.</li>
    </Ul>

    <H>4. Your content</H>
    <P>You retain ownership of the data you put into Vivo (profile info, notes, music metadata, documents linked from Google Drive, etc.). By using the Service you grant us the limited right to store and process that data solely to provide the Service to you and your band.</P>

    <H>5. Subscriptions &amp; trial</H>
    <Ul>
      <li>Every new band starts on a 30-day free trial with full functionality.</li>
      <li>After the trial, bands that wish to continue must subscribe (£5/month or £50/year) via Stripe.</li>
      <li>Payments are handled by Stripe; we never store your card details.</li>
      <li>You can cancel any time from the Subscription page. Refunds are at our discretion and in line with UK consumer law.</li>
    </Ul>

    <H>6. Availability &amp; limitations</H>
    <P>We aim for high uptime but provide the Service on an &ldquo;as-is&rdquo; basis. We do not guarantee the Service will be error-free or available at all times. We are not liable for indirect or consequential losses arising from your use of Vivo.</P>

    <H>7. Termination</H>
    <P>You may delete your account at any time from Profile → Danger Zone. We may suspend or terminate an account that breaches these Terms, after reasonable notice where practical.</P>

    <H>8. Privacy</H>
    <P>Your personal data is handled in accordance with our <a className="text-primary" href="/privacy">Privacy Policy</a>.</P>

    <H>9. Changes</H>
    <P>We may update these Terms from time to time. Material changes will be notified by email. Continued use of the Service after an update constitutes acceptance.</P>

    <H>10. Governing law</H>
    <P>These Terms are governed by the laws of England and Wales.</P>

    <H>11. Contact</H>
    <P>James Fiddeman · <a className="text-primary" href="mailto:james@support.vivomusicianmanagement.co.uk">james@support.vivomusicianmanagement.co.uk</a></P>
  </LegalLayout>
);

export default TermsOfService;
